import * as z from "zod";
import { StationProcessingSession } from "./station-processing-session";

export const getOpenStationProcessingSession = {
  name: "getOpenStationProcessingSession" as const,
  input: z.object({ workstationId: z.string() }),
  output: z.object({ session: StationProcessingSession.nullable() }),
};
